export const NBSP = ' ';
export const locale = 'nb-NO';
export const currency = 'kr';
export const oClock = 'kl.';
export const and = 'og';
export const NA = '—';
export const comma = ',';
